export const categories = [
    {

        name: 'Design'
    },
    {

        name: 'IT and Software'
    },
    {

        name: 'Marketing'
    },
    {

        name: 'Engineering'
    },
    {

        name: 'Cryptocurrency'
    }, {

        name: 'Agriculture'
    }, {

        name: 'Photography'
    }

]